import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/home';
import App from './pages/app';
import HowTo from './pages/howto';
import Docs from './pages/docs';

function AnalyticsPageView() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

export const AppRoutes = () => {
  return (
    <Router>
      <AnalyticsPageView />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/app" element={<App />} />
        <Route path="/howto" element={<HowTo />} />
        <Route path="/docs" element={<Docs />} />
      </Routes>
    </Router>
  );
};